/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.0012 0c.5523 0 1 .4477 1 1V9.25c0 .5523-.4477 1-1 1s-1-.4477-1-1V1c0-.5523.4477-1 1-1ZM4.929 4.9286c-3.9054 3.9053-3.9054 10.2371 0 14.1424 3.9053 3.9054 10.237 3.9054 14.1424 0 3.9053-3.9053 3.9053-10.237 0-14.1424-.3906-.3905-.3906-1.0236 0-1.4142.3905-.3905 1.0236-.3905 1.4142 0 4.6863 4.6864 4.6863 12.2845 0 16.9708-4.6864 4.6864-12.2845 4.6864-16.9708 0-4.6864-4.6863-4.6864-12.2844 0-16.9708.3905-.3905 1.0236-.3905 1.4142 0 .3905.3906.3905 1.0237 0 1.4142Z"
    clipRule="evenodd"
  />,
  'MenuLogout'
);
